module.exports = "/static/media/callsService.06501dba.svg";